import axios from '@/http/axios'

export function broadcasting ($payload = {}) {
  return axios({
    url: 'v1/broadcasting/auth?loading=false',
    data: $payload,
    method: 'post'
  })
}
